module.exports = require('./helpers/bundle-url').getBundleURL('jJ61j') + "logo.c51670a8.svg";